const _temp0 = require("./chatgpt.svg");
const _temp1 = require("./file-md.svg");
const _temp2 = require("./file-pdf.svg");
const _temp3 = require("./menu_aichat.svg");
const _temp4 = require("./menu_benchmark.svg");
const _temp5 = require("./menu_dashboard.svg");
const _temp6 = require("./menu_deal_details.svg");
const _temp7 = require("./menu_flowise_debug.svg");
const _temp8 = require("./menu_outputs.svg");
const _temp9 = require("./menu_score_details.svg");
const _temp10 = require("./menu_workstreams.svg");
const _temp11 = require("./sparkle.svg");
const _temp12 = require("./task-checkmark.svg");
const _temp13 = require("./task-circle.svg");
const _temp14 = require("./task-locked.svg");
const _temp15 = require("./task-paused.svg");
const _temp16 = require("./task-working.svg");
module.exports = {
  "chatgpt": _temp0,
  "file-md": _temp1,
  "file-pdf": _temp2,
  "menu_aichat": _temp3,
  "menu_benchmark": _temp4,
  "menu_dashboard": _temp5,
  "menu_deal_details": _temp6,
  "menu_flowise_debug": _temp7,
  "menu_outputs": _temp8,
  "menu_score_details": _temp9,
  "menu_workstreams": _temp10,
  "sparkle": _temp11,
  "task-checkmark": _temp12,
  "task-circle": _temp13,
  "task-locked": _temp14,
  "task-paused": _temp15,
  "task-working": _temp16
}